export default __webpack_public_path__ + "static/media/smartlink.d5e80ae9.webp";